export default class Payload {
    public data: object = {}

    public activateLoader: boolean = true

    public storeData: boolean = true

    constructor(data: object = {}, activateLoader: boolean = true, storeData: boolean = true) {
        this.data = data;
        this.activateLoader = activateLoader;
        this.storeData = storeData;
    }
}
